import React from "react";
import CgWallet from "../../../Component/Products/CgWallet";

const Maincgwallet = () => <CgWallet />;

export default Maincgwallet;
